import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { clx } from "../../utils/Helpers";

import "./_Header.scss";

const SectionTitle = ({ icon, label, classNames, LabelSx, IconSx }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: icon ? 1 : 0,
      mb: 2.5,
    }}
  >
    {icon ? (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          lineHeight: 0,
          color: "var(--color-primary-900)",
          fontSize: 16,
          "& .MuiSvgIcon-root": {
            fontSize: "1em",
            width: "1em",
            height: "1em",
          },
          ...IconSx,
        }}
      >
        {icon}
      </Box>
    ) : null}
    <Typography
      sx={{...LabelSx}}
      variant="caption"
      className={clx("section-title", classNames.label)}
    >
      {label}
    </Typography>
  </Box>
);

SectionTitle.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  classNames: PropTypes.object,
  LabelSx: PropTypes.object,
  IconSx: PropTypes.object,
};

SectionTitle.defaultProps = {
  icon: null,
  classNames: {},
  LabelSx: {},
  IconSx: {},
};

export default SectionTitle;
